'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    days: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: 16
    },
    day: {
      flex: '0 1 auto',
      width: 40,
      textAlign: 'center',
      padding: '10px 0 11px 0',
      boxSizing: 'border-box',
      borderRadius: theme.calendar.borderRadius,
      color: theme.calendar.textColor,
      marginTop: 4,
      marginLeft: 2,
      marginRight: 2,
      fontSize: 14,
      lineHeight: '19px',
      '&:nth-child(7n+1)': {
        marginLeft: 0
      },
      '&:nth-child(7n)': {
        marginRight: 0
      },
      '&:hover': {
        cursor: 'pointer',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.calendar.dayHoverColor,
        backgroundColor: theme.calendar.dayHoverBgColor,
        color: theme.calendar.dayHoverColor,
        padding: '9px 0 10px 0'
      },
      '&.active': {
        color: theme.calendar.dayActiveColor,
        '&:hover': {
          color: theme.calendar.dayHoverColor
        }
      },
      '&.disabled': {
        color: theme.calendar.dayDisabledColor + ' !important',
        '&:hover': {
          cursor: 'default',
          borderColor: 'transparent',
          backgroundColor: 'transparent'
        }
      },
      '&.otherMonth': {
        color: theme.calendar.dayOtherMonthColor,
        '&:hover': {
          color: theme.calendar.dayHoverColor
        }
      },
      '&.selected': {
        color: theme.calendar.daySelectedColor + ' !important',
        borderColor: theme.calendar.daySelectedBorderColor,
        backgroundColor: theme.calendar.daySelectedBgColor,
        '&:hover': {
          cursor: 'default'
        },
        '&.active:hover': {
          color: theme.calendar.daySelectedColor
        }
      }
    },
    small: {
      '&$days': {
        marginBottom: 12
      },
      '& $day': {
        width: 24,
        padding: '3px 0 4px 0',
        marginTop: 8,
        marginLeft: 4,
        marginRight: 4,
        fontSize: 12,
        lineHeight: '17px',
        '&:nth-child(7n+1)': {
          marginLeft: 0
        },
        '&:nth-child(7n)': {
          marginRight: 0
        },
        '&:hover': {
          padding: '2px 0 3px 0'
        }
      }
    }
  };
};